module.exports = __webpack_public_path__ + "static/media/BeIn_Sports.6d6c9345.png";